import { Button, Card, Space, Typography } from "antd";
import "./index.scss";
const { Text, Title } = Typography;

import paypal from "@/assets/img/paypal.png";
import visa from "@/assets/img/visa.png";
import publink from "@/assets/img/publink.png";
import successImg from "@/assets/svg/success.svg";
import { useState } from "react";

export const payWayList = [
  {
    value: "1",
    src: paypal,
  },
  {
    value: "2",
    src: visa,
  },
  {
    value: "3",
    src: publink,
  },
];

const PayMent = () => {
  const comfirmPay = () => {
    location.href =
      "https://publink.dev.kxsz.net/pay?order-id=AOI13397229819506688&sign=1728d1b14d2d778b2a7bc2f4be15b529";
  };
  return (
    <div className="payMent-box">
      <div className="" style={{ padding: 24 }}>
        <Title className="payment-title" level={4}>
          Publisher Payment System
        </Title>
      </div>
      <div className="infoBox">
        <Card className="info">
          <div className="item">Order No.: 2023002</div>
          <div className="item">Journal: Medical Research Journal </div>
          <div className="item">
            Article Title: Latest Advances in Cancer Treatment
          </div>
          <div className="item"> Contact Person's Name: Jane Doe</div>
          <div className="item"> Email: jane.doe@example.com</div>
          <div className="price">
            <span>Price:</span>
            <span>$1.00</span>
          </div>
        </Card>
        <Card className="payMethod">
          <div className="title">Payment method</div>
          <div className="pay-list">
            {payWayList.map((_way, index) => {
              return (
                <span
                  key={index}
                  className={`pay-item ${index === 2 ? "pay-selected" : ""}`}
                >
                  {index === 2 && (
                    <>
                      <img className="success-icon" src={successImg} alt="" />
                      <Text className="rmb-title">人民币支付</Text>
                    </>
                  )}
                  <img className="pay-icon" src={_way.src} alt="" />
                </span>
              );
            })}
          </div>
        </Card>

        <Button className="pay-btn" type="primary" onClick={comfirmPay}>
          Confirm payment
        </Button>
      </div>
    </div>
  );
};

export default PayMent;
